import { Redirect, Switch } from "react-router-dom";
import "../../assets/styles/Toastify.css";
import useAppRoutes from "./useAppRoutes";
import RouteWrapper from "./route-wrapper/RouteWrapper";
import { routePaths } from "../../shared/utils/constants/routePaths";
import GenericDialog from "components/ui/dialogs/generic-dialog/GenericDialog";
import { useEffect, useState } from "react";
import { Button, Grid } from "@material-ui/core";
import { useSelector } from "react-redux";
import { samlLogout } from "shared/utils/axiosUtils";
import PrivacyService from "api/privacyService";

const App = () => {
    const [routes] = useAppRoutes()
    const [isPrivacyDialogOpen, setIsPrivacyDialogOpen] = useState(false);
    const [privacyMessage, setPrivacyMessage] = useState();
    const [isConfirmButtonDisabled, setIsConfirmButtonDisabled] = useState(true);

    const token = useSelector((state) => state.authReducer.token);
    const username = useSelector((state) => state.authReducer.userClaims.uid);
    const typeUser = useSelector(state => state.authReducer.userClaims.typeUser);

    const onPrivacyConfirmed = () => {
        PrivacyService.acceptPrivacy(username)
            .then(() => {
                setIsPrivacyDialogOpen(false)
            })
            .catch((e) => {
                console.error(e.response.data)
            })
    };

    const handleScroll = (e) => {
        const { scrollTop, scrollHeight, clientHeight } = e.target;

        if (scrollTop + clientHeight >= scrollHeight - 10) {
            setIsConfirmButtonDisabled(false);
        }
    };

    const dialogActions = (
        <Grid container justifyContent="space-between">
            <Button variant="outlined"
                color="primary" onClick={() => samlLogout()}>
                Annulla
            </Button>

            <Button variant="contained"
                color="primary"
                disabled={isConfirmButtonDisabled} onClick={() => onPrivacyConfirmed()}>
                Conferma
            </Button>
        </Grid>
    )

    useEffect(() => {
        if(typeUser !== "operator") {
            const fetchPrivacyData = async () => {
                if (!token) return;

                try {
                    const privacyData = await PrivacyService.getPrivacy(username);

                    if (!privacyData.data) {
                        try {
                            const message = await PrivacyService.getPrivacyMessage();
                            setPrivacyMessage(message.data);
                            setIsPrivacyDialogOpen(true);
                        } catch (err) {
                            console.error('Error fetching privacy message:', err?.response?.data || err);
                        }
                    }
                } catch (err) {
                    console.error('Error fetching privacy data:', err?.response?.data || err);
                    setIsPrivacyDialogOpen(true);
                }
            };

            fetchPrivacyData();
        }
    }, [token, username]);

    return (
        <>
            <GenericDialog onScroll={handleScroll} open={isPrivacyDialogOpen}
                dialogContent={
                    <div dangerouslySetInnerHTML={{ __html: privacyMessage }} />
                }
                dialogActions={dialogActions} />
            <Switch>
                {routes.map((r) => (
                    <RouteWrapper key={r.path}
                        path={r.path}
                        exact
                        showRoute={r.guard}
                        component={r.component}
                        shouldRedirect={r.shouldRedirect}
                        redirectTo={r.redirectTo}
                        layout={r.layout} />
                ))}
                <Redirect to={routePaths.MOBILE} />
            </Switch>
        </>
    )
}

export default App
